module.exports = __webpack_public_path__ + "static/media/2.07617682.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/galeria/2.jpeg
// module id = 157
// module chunks = 0